import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";
import { getListOfArticles } from "~/slices/ListOfArticles/fragment";

const PAGE_TYPE = "Product_search_page";

const SEARCH_QUERY = gql`
  query product_search_page(
    $uid: String!
    $lazy: Boolean!
    $lang: String = "en-in"
  ) {
    ${PAGE_TYPE}: product_search_page(uid: $uid, lang: $lang) {
      title
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
      slices: body {
        ...${PAGE_TYPE}_list_of_articles
      }
    }
  }
  ${getListOfArticles(PAGE_TYPE)}
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
`;

export { PAGE_TYPE, SEARCH_QUERY };
